import { XIcon } from "@heroicons/react/outline";
import Button from "components/Button";
import IconButton from "components/Button/IconButton";
import Modal from "components/Modal";
import { useUserContext } from "context/UserContext";
import { getTranslation } from "dictionary";
import React from "react";

interface IRenderProps {
  openModal: () => void;
}

interface Props {
  onConfirm: () => void | Promise<void>;
  confirmLoading: boolean;
  message: string | (() => JSX.Element);
  title?: string;
  renderButton: (props: IRenderProps) => JSX.Element;
}
const ConfirmModal: React.FC<Props> = ({
  onConfirm,
  message,
  title,
  renderButton,
  confirmLoading,
}) => {
  const { language } = useUserContext();
  const [isOpen, setIsOpen] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const handleClose = () => setIsOpen(false);
  const handleOpen = () => setIsOpen(true);

  const handleConfirm = async () => {
    setIsLoading(true);
    await onConfirm();
    handleClose();
    setIsLoading(false);
  };
  return (
    <>
      {renderButton({
        openModal: handleOpen,
      })}
      <Modal isOpen={isOpen} onClose={handleClose}>
        <div className=" max-w-400 ml-auto mr-auto bg-white rounded-lg">
          <div className="w-full  font-medium flex  items-center justify-between px-6 py-4">
            {title || getTranslation("shared", "CONFIRM_MODAL_TITLE", language)}
            <IconButton Icon={XIcon} onClick={handleClose} />
          </div>
          <div className="w-full px-6 py-4 leading-6 border-t border-b border-gray-200 whitespace-pre-line">
            {typeof message === "string" ? message : message()}
          </div>
          <div className="flex justify-end items-center gap-4 w-full  px-6 py-4 ">
            <Button
              ariaLabel="cancel-button"
              onClick={handleClose}
              variant="secondary"
              size="medium"
              disabled={confirmLoading}
            >
              {getTranslation("shared", "CANCEL_BUTTON", language)}
            </Button>
            <Button
              ariaLabel="confirm-button"
              onClick={handleConfirm}
              variant="primary"
              size="medium"
              loading={confirmLoading || isLoading}
              disabled={confirmLoading || isLoading}
            >
              {getTranslation("shared", "CONFIRM_BUTTON", language)}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ConfirmModal;
